import { Controller } from 'react-hook-form';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Checkbox, Spacing } from '@zep/ui';
import { cn } from '@zep/utils';
import { usePlanStatusType } from '../hooks';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../PlanPaymentSection/Providers';
export const PlanTermsAgreement = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    locale = 'ko'
  } = useRouter();
  const {
    control,
    formState,
    watch
  } = usePlanPaymentFormContext();
  const {
    isUpdate
  } = usePlanPaymentInfoContext();
  const planType = watch('planType');
  const planStatusType = usePlanStatusType({
    planType
  });
  if (planStatusType === 'SAME_GRADE' && isUpdate) {
    return null;
  }
  return <>
      <div className="w-full rounded-[6px] border border-[#27262E14] bg-[#27262E0A] px-[20px] py-[12px]">
        <div className="flex w-full items-center">
          <span className="text-caption-1 font-[600] text-[#27262EA3]">
            {t('subscription:payment.summaryCommon.serviceTerms', '서비스 이용 약관')}
          </span>
          <a href={`https://docs.channel.io/zep-support/${locale}/articles/b40ac18f`} className="ml-auto text-[11px] font-[600] text-[#27262EA3] underline" target="_blank">
            {t('subscription:payment.summaryCommon.serviceTermsLink', '보기')}
          </a>
        </div>
        <Spacing size={6} data-sentry-element="Spacing" data-sentry-source-file="PlanTermsAgreement.tsx" />
        <div className="flex w-full items-center">
          <span className="text-caption-1 font-[600] text-[#27262EA3]">
            {t('subscription:payment.summaryCommon.refundPolicy', '환불 규정')}
          </span>
          <a href={t('subscription:checkout.refund.premiumGuideLink')} className="ml-auto text-[11px] font-[600] text-[#27262EA3] underline" target="_blank">
            {t('subscription:payment.summaryCommon.serviceTermsLink', '보기')}
          </a>
        </div>
      </div>
      <Spacing size={12} data-sentry-element="Spacing" data-sentry-source-file="PlanTermsAgreement.tsx" />
      <div>
        <Controller control={control} name="isTermsAgreed" defaultValue={false} render={({
        field
      }) => {
        return <Checkbox className="cursor-pointer" ref={field.ref} checked={field.value} onChange={field.onChange} size={20} label={<span className={cn('text-body-1 font-[600] text-gray-900', 'cursor-pointer', {
          'text-red': !!formState.errors.isTermsAgreed
        })}>
                    {t('subscription:payment.summaryCommon.checkBoxAgree', '모든 약관/환불/결제 정보를 확인하였고 동의합니다.')}
                  </span>} />;
      }} data-sentry-element="Controller" data-sentry-source-file="PlanTermsAgreement.tsx" />
      </div>
    </>;
};